import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'component.Commons.Search.placeholder',
    defaultMessage: 'Search',
  },
})
